exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-ba8d16a8]{background-color:#fff;position:relative;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;overflow-x:hidden}.wrapper html[data-v-ba8d16a8]{font-size:20px}.wrapper[data-v-ba8d16a8] img{width:100%!important;height:auto!important;vertical-align:top}.wrapper .no-data[data-v-ba8d16a8]{margin-top:40%;font-size:.6rem;text-align:center;color:#c5c5c5}.wrapper[data-v-ba8d16a8] .van-tab{color:#727272}.wrapper[data-v-ba8d16a8] .van-tab--active{color:#343434}.wrapper[data-v-ba8d16a8] .van-tabs__line{background-color:#c8a15c;width:34px}.wrapper[data-v-ba8d16a8] .van-tabs__content{width:90%;padding:0 5%;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba8d16a8","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/scanBranding.vue
// module id = ttHk
// module chunks = 1